/* DillySocks — Navigation (Desktop-Flyout + Mobile-Menü). Vanilla, kein Framework. */
(function () {
  'use strict';
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  // ---- Such-Empfehlungen: Panel bei Fokus auf die Suchleiste ----
  function initSearchSuggest(root) {
    var desk = root.querySelector('[data-ds-sgs]');
    var mob = root.querySelector('[data-ds-sgs-mobile]');
    var deskInput = root.querySelector('.ds-hd__search input');
    var mobInput = root.querySelector('.ds-hd__m-search input');

    function open(panel) { if (panel) panel.hidden = false; }
    function close(panel) { if (panel) panel.hidden = true; }

    if (desk && deskInput) {
      deskInput.addEventListener('focus', function () { open(desk); });
      document.addEventListener('click', function (e) {
        if (desk.hidden) return;
        if (desk.contains(e.target)) return;
        if (e.target.closest && e.target.closest('.ds-hd__search')) return;
        close(desk);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close(desk);
      });
    }
    if (mob && mobInput) {
      mobInput.addEventListener('focus', function () { open(mob); });
      // Tippt jemand, bleibt das Panel offen; X/ESC oder Menü-Schliessen räumt auf
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close(mob);
      });
      var closeBtn = root.querySelector('[data-ds-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { close(mob); });
      var backBtn = root.querySelector('[data-ds-back]');
      if (backBtn) backBtn.addEventListener('click', function () { close(mob); });
    }
    /* Der Such-Modus zeigt die Vorschlaege sofort (Figma-Dropdown) —
       nicht erst beim Fokus-Event, das je nach Browser verschluckt wird. */
    root.dsOpenSgsMobile = function () { open(mob); };
    root.dsCloseSgsMobile = function () { close(mob); };
  }

  function initHeader(root) {
    if (root.dataset.dsNavReady) return;
    root.dataset.dsNavReady = '1';

    /* ---------- Schwebende Pille: Verdichtung beim Scrollen ----------
       WICHTIG: Horizon scrollt auf dem Desktop NICHT im Fenster, sondern in
       einem inneren Container (.page-wrapper, overflow: auto) — window.scrollY
       bleibt dort immer 0. Deshalb am echten Scroll-Container lauschen;
       window zusätzlich als Fallback (z.B. Mobile). */
    var scroller = document.querySelector('.page-wrapper');
    var shrunk = false;
    function scrollPos() {
      var w = window.scrollY || 0;
      var s = scroller ? scroller.scrollTop : 0;
      return Math.max(w, s);
    }
    /* Schwelle = natürliche Position der Pille im Dokument (≈ Höhe der
       Ankündigungsleiste). So wird sie exakt in dem Moment angeheftet, in dem
       sie den Fensterrand erreicht — ohne sichtbaren Sprung. */
    var stickAt = 24;
    function measureStickAt() {
      if (shrunk) return; /* nur im normalen Zustand messbar */
      var r = root.getBoundingClientRect();
      stickAt = Math.max(8, r.top + scrollPos() - 4);
    }
    measureStickAt();
    window.addEventListener('resize', measureStickAt);

    /* ---------- Links-Verdichtung: Zielmasse messen ----------
       Die Pille bleibt in BEIDEN Zuständen per margin:auto zentriert (das
       korrigiert sich bei jeder Layout-Änderung von selbst — Drawer, Resize).
       Nur die Links-Verschiebung im verdichteten Zustand wird gemessen:
       --ds-pill-max   Breite (bis zur Buy-Box-Kante, sonst 900px)
       --ds-pill-shift translate von der Mitte an die linke Inhaltskante
       Nach Resize/Drawer wird OHNE Animation nachgeführt (Klasse --noanim),
       damit nichts durch die Gegend gleitet. */
    /* Referenzmasse der Pille im NORMALZUSTAND. Waehrend/nach dem Schrumpfen
       ist bar.clientWidth die verkleinerte Pille - wer damit rechnet, macht
       die Pille bei jeder Messung kleiner (Feedback-Schleife: "oft hoch und
       runter scrollen laesst die Pille zusammenschnurren"). */
    var pillNorm = null;
    function measurePill(animate) {
      if (window.innerWidth < 990) return;
      var bar = root.querySelector('.ds-hd__bar');
      if (!bar) return;
      if (!shrunk) {
        var normPad = parseFloat(getComputedStyle(bar).paddingLeft) || 0;
        var normW = bar.clientWidth - normPad * 2;
        if (normW >= 300) {
          pillNorm = { padL: normPad, containerW: normW, barLeft: bar.getBoundingClientRect().left };
        }
      }
      if (!pillNorm) return; // noch nie sauber gemessen
      var padL = pillNorm.padL;
      var containerW = pillNorm.containerW;
      var barRect = { left: pillNorm.barLeft };
      if (containerW < 300) return; // Layout noch nicht bereit -> keine Schrott-Werte setzen

      // Inhaltskante: NACHEINANDER prüfen (eine Selektor-Liste liefert immer
      // das erste Element in DOKUMENT-Reihenfolge — das wäre stets <main>
      // selbst, links=0). Rechnerischer Fallback: zentrierte Inhaltsbreite.
      var contentLeft = 0;
      var probes = ['.ds-breadcrumbs', 'main .section-content', 'main .section'];
      for (var i = 0; i < probes.length && !contentLeft; i++) {
        var el = document.querySelector(probes[i]);
        if (el) {
          var pl = el.getBoundingClientRect().left;
          if (pl > 8) contentLeft = pl;
        }
      }
      if (!contentLeft) {
        contentLeft = Math.max((window.innerWidth - 1520) / 2, 0) + 40;
      }

      // Kauf-Bereich: Standard-PDP ODER unsere Abo-/Advent-Kaufspalte.
      // Karten-Quick-Adds (Collection-Seiten) zaehlen NICHT als Buy-Box -
      // sonst rutscht die verdichtete Pille auf Kollektionsseiten nach links.
      var buy = document.querySelector('.product-details button[name="add"], product-form-component button[type="submit"], .buy-buttons-block, .ds-abo__buy, .ds-adv__buy');
      if (buy && buy.closest('.product-card, .quick-add, quick-add-component')) buy = null;
      var maxW = 900;
      if (buy) {
        var bl = buy.getBoundingClientRect().left;
        if (bl > 500) maxW = Math.max(560, Math.round(bl - contentLeft - 16));
      }
      // Nie breiter als der Platz zwischen Inhaltskante und rechtem Rand
      maxW = Math.min(maxW, containerW, Math.round(barRect.left + padL + containerW - contentLeft));
      // Sicherheitsnetz: nie unter eine nutzbare Breite fallen (Logo, Suche
      // und Icons brauchen Platz; ohne Buy-Box gibt es keinen Grund fuer
      // eine schmale Pille).
      var minW = buy ? 560 : 820;
      maxW = Math.max(maxW, Math.min(minW, containerW));

      // Nach links (an die Inhaltskante) NUR auf der PDP, wo die Pille sonst
      // die Buy-Box verdecken wuerde. Ueberall sonst (Home, Collections)
      // bleibt die verdichtete Pille zentriert.
      var shift = 0;
      if (buy) {
        var centeredLeft = barRect.left + padL + (containerW - maxW) / 2;
        shift = Math.round(contentLeft - centeredLeft);
        if (shift > 0) shift = 0; // nie nach rechts schieben
      }

      if (!animate) root.classList.add('ds-hd--noanim');
      root.style.setProperty('--ds-pill-max', maxW + 'px');
      root.style.setProperty('--ds-pill-shift', shift + 'px');
      if (!animate) {
        void root.offsetWidth; // Style-Flush, dann Animationen wieder zulassen
        root.classList.remove('ds-hd--noanim');
      }
    }
    measurePill(true);
    setTimeout(function () { measurePill(true); }, 600);
    var measureTimer = null;
    function remeasureSoon() {
      clearTimeout(measureTimer);
      measureTimer = setTimeout(function () { measurePill(false); }, 120);
    }
    window.addEventListener('resize', remeasureSoon);
    /* Drawer (Warenkorb/Filter) verengen die Seite -> nach dem
       Auf-/Zuklappen nachmessen. Die Pille selbst bleibt unangetastet:
       sie squeezt als Teil des page-wrappers automatisch mit (Sean 26.08.,
       vorher wurde sie beim Warenkorb kuenstlich in is-shrunk gezwungen). */
    ['#cart-drawer dialog', '#filters-drawer dialog'].forEach(function (sel) {
      var dlg = document.querySelector(sel);
      if (dlg && 'MutationObserver' in window) {
        new MutationObserver(function () {
          setTimeout(function () { measurePill(false); }, 380);
        }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
      }
    });

    function onScroll() {
      var should = scrollPos() > stickAt;
      if (should !== shrunk) {
        if (should) measurePill(true); // frische Masse exakt im Moment des Anheftens
        shrunk = should;
        root.classList.toggle('is-shrunk', shrunk);
      }
      /* Sicherung: ganz oben darf die Pille NIE verdichtet/fixiert sein —
         auch wenn Zustandsvariable und DOM-Klasse auseinandergelaufen sind
         (Chrome iOS, elastisches Zurueckfedern ohne finales Scroll-Event). */
      if (!should && scrollPos() <= 2 && root.classList.contains('is-shrunk')) {
        root.classList.remove('is-shrunk');
        shrunk = false;
      }
    }
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    /* Chrome iOS: Das Ein-/Ausfahren der Adressleiste beim Scrollen feuert
       RESIZE (nicht zwingend ein finales Scroll-Event) — dabei konnte der
       verdichtete Zustand am Seitenanfang "haengen bleiben" (Pille fixed,
       Inhalt rutschte optisch unter den Header). Zustand deshalb auch bei
       Resize/Orientation/Sichtbarkeitswechsel neu bewerten. */
    window.addEventListener('resize', onScroll);
    window.addEventListener('orientationchange', onScroll);
    document.addEventListener('visibilitychange', onScroll);
    onScroll();

    /* ---------- Warenkorb-Zähler: "Pop" bei Änderung ---------- */
    var bubble = root.querySelector('.ds-hd__cart .cart-bubble');
    if (bubble && 'MutationObserver' in window) {
      var lastCount = bubble.textContent;
      new MutationObserver(function () {
        if (bubble.textContent !== lastCount) {
          lastCount = bubble.textContent;
          bubble.classList.remove('ds-badge-pop');
          void bubble.offsetWidth; /* Animation neu starten */
          bubble.classList.add('ds-badge-pop');
        }
      }).observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    var burger = root.querySelector('[data-ds-burger]');
    var flyout = root.querySelector('[data-ds-flyout]');
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-ds-cat]'));
    var megaCats = Array.prototype.slice.call(root.querySelectorAll('[data-ds-mega-cat]'));
    var bar = root.querySelector('.ds-hd__bar');
    var mobile = root.querySelector('[data-ds-mobile]');
    var scrim = root.querySelector('[data-ds-scrim]');
    var subPanels = Array.prototype.slice.call(root.querySelectorAll('[data-ds-panel-sub]'));
    var closeTimer = null;

    /* ---------- Desktop flyout ---------- */
    function activateCat(idx) {
      cats.forEach(function (c) { c.classList.toggle('is-active', c.dataset.dsCat === idx); });
      megaCats.forEach(function (m) { m.hidden = (m.dataset.dsMegaCat !== idx); });
    }
    function openFlyout() {
      if (!flyout) return;
      clearTimeout(closeTimer);
      var anyActive = cats.some(function (c) { return c.classList.contains('is-active'); });
      if (!anyActive && cats.length) activateCat(cats[0].dataset.dsCat);
      flyout.classList.add('is-open');
      if (burger) { burger.classList.add('is-open'); burger.setAttribute('aria-expanded', 'true'); }
    }
    function closeFlyout() {
      if (!flyout) return;
      flyout.classList.remove('is-open');
      if (burger) { burger.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); }
    }

    cats.forEach(function (c) {
      c.addEventListener('mouseenter', function () { activateCat(c.dataset.dsCat); });
      c.addEventListener('focus', function () { openFlyout(); activateCat(c.dataset.dsCat); });
    });

    /* ---------- Mobile menu ---------- */
    function openMobile() {
      root.classList.add('is-mobile-open');
      if (mobile) mobile.hidden = false;
      if (scrim) { scrim.hidden = false; scrim.classList.add('is-visible'); }
      if (burger) { burger.classList.add('is-open'); burger.setAttribute('aria-expanded', 'true'); }
      document.body.style.overflow = 'hidden';
    }
    /* Such-Modus (Figma "Navi-search-pop-up"): kompaktes Dropdown mit
       Kopfzeile [Burger | Logo | Suchfeld | Warenkorb]. Vorschlaege sofort
       sichtbar; der Burger in der Kopfzeile wechselt zurueck ins Menue. */
    function openMobileSearch() {
      openMobile();
      root.classList.add('is-msearch');
      if (typeof root.dsOpenSgsMobile === 'function') root.dsOpenSgsMobile();
      var inp = mobile ? mobile.querySelector('.ds-hd__m-search input') : null;
      if (inp) setTimeout(function () { inp.focus(); }, 380);
    }
    /* Mobile-Suchicon in der Pille: öffnet das Menü direkt im Such-Modus */
    var msearch = root.querySelector('[data-ds-msearch]');
    if (msearch) msearch.addEventListener('click', openMobileSearch);
    /* Such-Icon in der Panel-Topzeile */
    var msearchInner = root.querySelector('[data-ds-msearch-inner]');
    if (msearchInner) msearchInner.addEventListener('click', openMobileSearch);

    function backMobile() {
      root.classList.remove('is-sub');
      subPanels.forEach(function (p) { p.style.transform = 'translateX(100%)'; });
    }
    function closeMobile() {
      root.classList.remove('is-mobile-open');
      root.classList.remove('is-msearch');
      if (scrim) scrim.classList.remove('is-visible');
      if (burger) { burger.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); }
      document.body.style.overflow = '';
      setTimeout(function () {
        backMobile();
        if (mobile) mobile.hidden = true;
        if (scrim) scrim.hidden = true;
      }, 320);
    }
    function openCat(idx) {
      subPanels.forEach(function (p) {
        p.hidden = false;
        p.style.transform = (p.dataset.dsPanelSub === idx) ? 'translateX(0)' : 'translateX(100%)';
      });
      root.classList.add('is-sub');
    }

    // Subpanels sichtbar (aber off-screen) machen, damit Transitions greifen.
    subPanels.forEach(function (p) { p.hidden = false; p.style.transform = 'translateX(100%)'; });

    root.querySelectorAll('[data-ds-open]').forEach(function (tile) {
      tile.addEventListener('click', function (e) { e.stopPropagation(); openCat(tile.dataset.dsOpen); });
    });
    var backBtn = root.querySelector('[data-ds-back]');
    if (backBtn) backBtn.addEventListener('click', backMobile);
    var closeBtn = root.querySelector('[data-ds-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      /* Im Such-Modus zeigt der Button ein Burger-Icon: zurueck ins Menue
         statt schliessen (Figma). Sonst: X = alles zu. */
      if (root.classList.contains('is-msearch')) {
        root.classList.remove('is-msearch');
        if (typeof root.dsCloseSgsMobile === 'function') root.dsCloseSgsMobile();
        return;
      }
      closeMobile();
    });
    if (scrim) scrim.addEventListener('click', closeMobile);

    /* ---------- Burger: je nach Viewport Flyout oder Mobile-Menü ---------- */
    if (burger) {
      burger.addEventListener('mouseenter', function () { if (DESKTOP.matches) openFlyout(); });
      burger.addEventListener('click', function () {
        if (DESKTOP.matches) {
          flyout && flyout.classList.contains('is-open') ? closeFlyout() : openFlyout();
        } else {
          root.classList.contains('is-mobile-open') ? closeMobile() : openMobile();
        }
      });
    }

    if (bar) {
      bar.addEventListener('mouseleave', function () { if (DESKTOP.matches) closeTimer = setTimeout(closeFlyout, 160); });
      bar.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeFlyout(); if (root.classList.contains('is-mobile-open')) closeMobile(); }
    });
  }

  /* "Nur reduzierte Artikel"-Schalter im Filter-Drawer.
     Nutzt die (per CSS versteckte) Facet-Gruppe auf dem Metafeld
     global.discount_percent_chf als serverseitigen Motor: Schalter an =
     alle Prozentwerte ausser "0" ankreuzen. Damit stimmen Zaehler und
     Pagination, und neue Rabattstufen funktionieren automatisch. */
  function initFacetSale() {
    if (initFacetSale._done) return;
    initFacetSale._done = true;
    function upgrade(form) {
      if (!form || form.querySelector('.ds-sale-row')) return;
      var inputs = Array.prototype.slice.call(
        form.querySelectorAll('input[name*="discount_percent"]')
      );
      if (!inputs.length) return;
      var nonzero = inputs.filter(function (i) { return parseFloat(i.value) > 0; });
      if (!nonzero.length) return;
      var row = document.createElement('label');
      row.className = 'ds-sale-row';
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = nonzero.some(function (i) { return i.checked; });
      var txt = document.createElement('span');
      txt.className = 'ds-sale-row__label';
      txt.innerHTML = '<i class="fa-solid fa-tag" aria-hidden="true"></i> Nur reduzierte Artikel';
      row.appendChild(cb);
      row.appendChild(txt);
      var first = form.querySelector('.facets__item');
      if (first && first.parentNode) {
        first.parentNode.insertBefore(row, first);
      } else {
        form.appendChild(row);
      }
      cb.addEventListener('change', function () {
        inputs.forEach(function (i) { i.checked = false; });
        if (cb.checked) nonzero.forEach(function (i) { i.checked = true; });
        nonzero[0].dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    /* Desktop-Toolbar: die Horizon-Facettenzeile (deren Pills/Zaehler/Sortierung
       per CSS versteckt sind) wird zur einen Filterzeile umgebaut:
       [DS-Filter-Button][geklonte Quicklink-Pills] ......... [Rasterwahl].
       Der DS-Button proxy-klickt Horizons Original-Button (der unsichtbar an
       seinem Platz bleibt - nur dort funktioniert sein Drawer-Binding). */
    function upgradeToolbar() {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      var form = document.querySelector('div.facets-block-wrapper form.facets__form');
      if (!form || form.querySelector('.ds-ftb')) return;
      var origBtn = document.querySelector('.facets-toggle .facets-toggle__button');
      if (!origBtn) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ds-ftb';
      b.setAttribute('aria-haspopup', 'dialog');
      b.innerHTML = '<i class="fa-solid fa-sliders" aria-hidden="true"></i> Filtern';
      b.addEventListener('click', function () {
        var openDlg = Array.prototype.find.call(
          document.querySelectorAll('dialog[open]'),
          function (d) { return d.querySelector('form.facets__form'); }
        );
        if (openDlg) {
          var comp = openDlg.closest('theme-drawer') || document.getElementById('filters-drawer');
          if (comp && typeof comp.close === 'function') {
            comp.close();
          } else {
            var x = openDlg.querySelector('.theme-drawer__close-button');
            if (x) { x.click(); } else { openDlg.close(); }
          }
        } else {
          origBtn.click();
        }
      });
      form.insertBefore(b, form.firstChild);
      var anchor = form.querySelector('.facets__filters-wrapper');
      document.querySelectorAll('.ds-tag-pills__row .ds-tag-pills__pill').forEach(function (p) {
        var c = p.cloneNode(true);
        c.classList.add('ds-ftb-pill');
        form.insertBefore(c, anchor);
      });
    }

    /* Aufraeumarbeiten rund um den Sale-Schalter: die rohen Prozent-Chips
       ("10 x", "20 x", ...) verstecken und den Filter-Zaehler im Drawer-
       Header von "8 Prozentwerte" auf "1 Sale-Filter" korrigieren. */
    function tidySaleChips() {
      var vals = {};
      document.querySelectorAll('input[name*="discount_percent"]').forEach(function (i) { vals[i.value] = true; });
      document.querySelectorAll('facet-remove-component').forEach(function (ch) {
        var t = ch.textContent.replace(/entfernen|remove|l\u00f6schen/gi, '').replace(/[\u00d7\u2715\s]/g, '');
        if (vals[t]) ch.style.display = 'none';
      });
      var dlg = document.querySelector('dialog[open]');
      if (!dlg) return;
      var badge = dlg.querySelector('.theme-drawer__badge');
      if (!badge || badge.dataset.dsDone === badge.textContent.trim()) return;
      var checked = 0;
      dlg.querySelectorAll('input[name*="discount_percent"]').forEach(function (i) { if (i.checked) checked++; });
      if (checked > 1) {
        var n = parseInt(badge.textContent.trim(), 10);
        if (!isNaN(n) && n >= checked) {
          var target = String(n - checked + 1);
          badge.dataset.dsDone = target;
          badge.textContent = target;
        }
      }
    }

    /* Raster-Umschalter (4/5 Spalten): Horizons on:change-Binding springt
       auf den Radios in der reduzierten Toolbar nicht zuverlaessig an -
       delegierter Listener setzt das product-grid-view-Attribut direkt
       (identisch zu results-list.js updateLayout, inkl. sessionStorage). */
    if (!initFacetSale._gridSwitch) {
      initFacetSale._gridSwitch = true;
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!(t instanceof HTMLInputElement) || t.name !== 'grid') return;
        document.querySelectorAll('.product-grid').forEach(function (grid) {
          grid.setAttribute('product-grid-view', t.value);
        });
        try {
          var viewport = window.matchMedia('(min-width: 990px)').matches ? 'desktop' : 'mobile';
          sessionStorage.setItem('product-grid-view-' + viewport, t.value);
        } catch (err) {}
      });
    }

    /* Aktive Filter — EINE Quelle fuer alle Filter-Buttons (Mobile-Toggle,
       Desktop-.ds-ftb, Sticky-FAB): Horizons Count-Bubble im Toggle-Button
       (total_active_values, wird bei jedem Filter-Update neu gerendert).
       Fallback: filter.*-Parameter der URL. Der Sale-Schalter setzt mehrere
       discount_percent-Werte auf einmal -> zaehlt als EIN Filter (wie
       tidySaleChips im Drawer-Header). */
    function activeFilterCount() {
      /* Direkt zaehlen statt Horizons Bubble zu korrigieren (Bubble und
         Checkbox-Zustand aktualisieren zu unterschiedlichen Zeitpunkten —
         das Verrechnen zeigte mal 5, mal 1 statt 3; Sean 19./20.08.).
         Regel: jede aktive Filteroption = 1; der Sale-Schalter ("Nur
         reduzierte Artikel") setzt intern ALLE discount_percent-Werte und
         zaehlt zusammen als GENAU 1. Die Facetten-Form existiert doppelt
         (Toolbar + Drawer) -> ueber name=value dedupliziert. */
      var seen = {};
      var n = 0;
      var sale = false;
      var found = false;
      document.querySelectorAll('form.facets__form input[name^="filter."]:checked').forEach(function (i) {
        found = true;
        if (i.name.indexOf('discount_percent') !== -1) { sale = true; return; }
        var key = i.name + '=' + i.value;
        if (seen[key]) return;
        seen[key] = true;
        n++;
      });
      if (!found) {
        /* Kein Formular auf der Seite (oder noch nicht gerendert):
           URL-Parameter mit derselben Regel zaehlen. */
        try {
          new URLSearchParams(location.search).forEach(function (v, k) {
            if (k.indexOf('filter.') !== 0 || v === '') return;
            if (k.indexOf('discount_percent') !== -1) { sale = true; return; }
            var key = k + '=' + v;
            if (seen[key]) return;
            seen[key] = true;
            n++;
          });
        } catch (e) { /* egal */ }
      }
      if (sale) n++;
      return n;
    }    window.dsActiveFilterCount = activeFilterCount;

    /* Active-State + Zaehler-Badge auf allen Filter-Buttons setzen. */
    function ensureBadge(btn) {
      var badge = btn.querySelector('.ds-filter-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ds-filter-badge';
        badge.hidden = true;
        btn.appendChild(badge);
      }
      return badge;
    }
    function syncFilterButtons() {
      var n = activeFilterCount();
      document.querySelectorAll('.facets-toggle__button, .ds-ftb, .ds-filter-fab').forEach(function (btn) {
        btn.classList.toggle('is-active', n > 0);
        /* Mobile-Toggle: Horizons Bubble als Badge weiternutzen (nur Zahl
           korrigieren), sonst eigenes Badge-Element */
        /* Nur schreiben, wenn sich etwas aendert — der Body-MutationObserver
           (scan) wuerde sonst durch den eigenen Text-Update erneut feuern. */
        var bubbleText = btn.querySelector('.filter-count-bubble__text');
        if (bubbleText) {
          if (n > 0 && bubbleText.textContent.trim() !== String(n)) bubbleText.textContent = n;
          return;
        }
        var badge = ensureBadge(btn);
        if (badge.textContent !== String(n)) badge.textContent = n;
        badge.hidden = n === 0;
      });
    }
    window.dsSyncFilterButtons = syncFilterButtons;
    window.addEventListener('popstate', syncFilterButtons);
    window.addEventListener('pageshow', syncFilterButtons);

    /* Default-Zustand der Filtergruppen im Drawer (Sean 25.08.):
       "Farbe" offen, alle anderen zu — Desktop wie Mobile. Manuell
       umgeschaltete Gruppen bleiben ueber AJAX-Filter-Updates erhalten:
       jedes toggle-Ereignis wird pro Gruppenname gemerkt und nach einem
       Re-Render wieder angewendet (das Serverside-Markup liefert alle
       Gruppen offen). Kein CLS: alles passiert im versteckten Drawer. */
    var facetOpenState = {};
    function facetName(details) {
      var sm = details.querySelector('summary');
      return sm ? sm.textContent.replace(/\s+/g, ' ').trim().split(' ')[0] : '';
    }
    function initFacetPanels() {
      var pending = [];
      document.querySelectorAll('dialog .facets__panel, theme-drawer .facets__panel, #filters-drawer .facets__panel').forEach(function (d) {
        if (d.dataset.dsPanelInit) return;
        d.dataset.dsPanelInit = '1';
        var name = facetName(d);
        var open;
        if (name in facetOpenState) {
          open = facetOpenState[name];
        } else {
          open = name.indexOf('Farbe') === 0;
        }
        if (d.open !== open) pending.push({ el: d, open: open });
        d.addEventListener('toggle', function () {
          facetOpenState[name] = d.open;
        });
      });
      /* open-Attribute gebuendelt nach dem Frame setzen — vermeidet
         synchrone Style-Recalcs mitten in der Drawer-Oeffnung (INP). */
      if (pending.length) {
        requestAnimationFrame(function () {
          pending.forEach(function (p) {
            if (p.el.open !== p.open) p.el.open = p.open;
          });
        });
      }
    }

    function scan() {
      document.querySelectorAll('form.facets__form').forEach(upgrade);
      upgradeToolbar();
      tidySaleChips();
      syncFilterButtons();
      initFacetPanels();
    }
    /* INP: Horizon baut den Filter-Drawer bei jedem Oeffnen/AJAX-Update neu.
       Ein ungefilterter Body-MutationObserver hat dabei scan() synchron in
       der Klick-Phase mehrfach ausgefuehrt (Sale-Row, Panel-open, Badges) und
       Style-Recalc erzwungen. Deshalb: nur Facetten-/Ergebnis-Subtree
       beobachten, debounced, und eigene DOM-Writes waehrend scan() ignorieren. */
    var scanTimer = null;
    var scanning = false;
    function scheduleScan() {
      if (scanning) return;
      clearTimeout(scanTimer);
      scanTimer = setTimeout(function () {
        scanning = true;
        try {
          scan();
        } finally {
          /* Eigene Inserts (Sale-Row, Badges) sollen den Observer nicht
             sofort wieder anstossen — einen Frame spaeter freigeben. */
          requestAnimationFrame(function () {
            scanning = false;
          });
        }
      }, 200);
    }
    function observeFacetRoots() {
      var roots = [];
      var drawer = document.getElementById('filters-drawer');
      if (drawer) roots.push(drawer);
      document.querySelectorAll('.facets-block-wrapper, results-list, collection-component').forEach(function (el) {
        roots.push(el);
      });
      if (!roots.length) roots.push(document.body);
      roots.forEach(function (root) {
        if (root.dataset && root.dataset.dsFacetMo) return;
        if (root.dataset) root.dataset.dsFacetMo = '1';
        new MutationObserver(scheduleScan).observe(root, { childList: true, subtree: true });
      });
    }
    scan();
    observeFacetRoots();
    document.addEventListener('shopify:section:load', observeFacetRoots);
  }

  function boot() {
    document.querySelectorAll('[data-ds-hd]').forEach(function (root) {
      initHeader(root);
      initSearchSuggest(root);
    });
    initFacetSale();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
